import { render, staticRenderFns } from "./class-settings.vue?vue&type=template&id=5f32b298&"
import script from "./class-settings.ts?vue&type=script&lang=ts&"
export * from "./class-settings.ts?vue&type=script&lang=ts&"
import style0 from "./class-settings.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports